import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Header from './Components/Header';
import MainFeaturedPost from './Components/MainFeaturedPost';
import FeaturedPost from './Components/FeaturedPost';
import Main from './Components/Main';
import Sidebar from './Components/Sidebar';
import Footer from './Components/Footer';

import post1 from './Resources/blog-post.1.md';

const sections = [
  { title: 'Technology', url: '#' },
  { title: 'Design', url: '#' },
  { title: 'TODO', url: '#' },
];

const mainFeaturedPost = {
  title: 'Currently a work in progress',
  description:
    "This blog post is currently hardcoded and copied from Mui Templates. Currently working to develop a serverless backend then we'll have some real blogs running.",
  image: 'https://source.unsplash.com/random',
  imageText: 'main image description',
  linkText: 'Continue reading…',
};

const featuredPosts = [
  {
    title: 'Featured post',
    date: 'Nov 12',
    description:
      'This is a wider card with supporting text below as a natural lead-in to additional content.',
    image: 'https://source.unsplash.com/random',
    imageLabel: 'Image Text',
  },
  {
    title: 'Post title',
    date: 'Nov 11',
    description:
      'This is a wider card with supporting text below as a natural lead-in to additional content.',
    image: 'https://source.unsplash.com/random',
    imageLabel: 'Image Text',
  },
];

const posts = [post1];

const sidebar = {
  title: 'About',
  description:
    "This Blog in built in React, it's deployed on AWS and is delivered by Terraform and Github Actions. The backend is powered by Python using serverless technology",
  archives: [
    { title: 'March 2020', url: '#' },
    { title: 'February 2020', url: '#' },
    { title: 'January 2020', url: '#' },
  ],
};

const theme = createTheme();

export default function Blog() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg">
        <Header title="Blog" sections={sections} />
        <main>
          <MainFeaturedPost post={mainFeaturedPost} />
          <Grid container spacing={4}>
            {featuredPosts.map((post) => (
              <FeaturedPost key={post.title} post={post} />
            ))}
          </Grid>
          <Grid container spacing={5} sx={{ mt: 3 }}>
            <Main title="Some Musings" posts={posts} />
            <Sidebar
              title={sidebar.title}
              description={sidebar.description}
              archives={sidebar.archives}
            />
          </Grid>
        </main>
      </Container>
      <Footer
        title=""
        description="Hope you enjoyed Rhodh musings"
      />
    </ThemeProvider>
  );
}
